export default __webpack_public_path__ + "static/logo1-754eef076bdf824c4e2faa74eeba7771.png";